import { render, staticRenderFns } from "./CarTransfer.vue?vue&type=template&id=ec8c8a1a&scoped=true"
import script from "./CarTransfer.vue?vue&type=script&lang=js"
export * from "./CarTransfer.vue?vue&type=script&lang=js"
import style0 from "./CarTransfer.vue?vue&type=style&index=0&id=ec8c8a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8c8a1a",
  null
  
)

export default component.exports